import { TimeOut } from "../configs/base";
import Core from "@sonphat/core";
import AuthApi from "../bootstrap/AuthApi";
import addBothCases from "../src/utils/caseMapper";

const SP = window.SP;
const $Core = new Core({
    // Cấu hình xác thực truy cập, bắt buộc có nếu muốn tải tải trình xác thực
    // Auth: new AuthApi,
    Auth: {
        Keycloak: SP["keycloak"] || {
            URL: "https://dangnhap.sbus.vn/auth",
            Realm: "Sbus.vn",
            ClientId: "LenhDienTu",
        },
    },
    // cấu hình cho api
    Api: {
        BaseURL: SP["API_Default_BaseUrl"] || "https://localhost:5001/",

        Timeout: TimeOut, // (ms), 5s === 5000 ms

        NoExceptionHttpStatus: false,
        Custom: (cfg) => {
            var auth = new AuthApi();
            if (cfg.headers) {
                // var tokenParsed = JSON.parse(localStorage.getItem("token")) || null;
                cfg.headers["Authorization"] = `Bearer ${auth.Token}`;
                cfg.headers["Fe_Version"] = window.SP["Fe_Version"] || "";
            }
            return cfg;
        },
    },
    Helper: {
        // cấu hình helper
        Format: {
            // cấu hình default format, $Core.Helper.Format.Datetime(new Date(), format)
            DatetimeDefaultFormat: `{yyyy}/{mm}/{dd} {hh}:{ii}:{ss}.{ms}`,
        },
    },
});
$Core.AuthApi = new AuthApi();

/**
 * Bọc các method trả về dữ liệu (Get/Post/Put/Delete) của 1 request-builder
 * để map response.Data sang cả 2 kiểu key: chữ HOA đầu và chữ thường đầu.
 */
// Bọc ApiResponse: transform khi ĐỌC .Data (getter-only nên không gán đè được).
function wrapApiResponse(result) {
    if (!result || typeof result !== "object") return result;
    let cached;
    let computed = false;
    return new Proxy(result, {
        get(t, p) {
            if (p === "Data") {
                if (!computed) {
                    cached = addBothCases(Reflect.get(t, "Data", t));
                    computed = true;
                }
                return cached;
            }
            return Reflect.get(t, p, t);
        },
    });
}

/**
 * Bọc request-builder bằng Proxy:
 * - Get/Post/Put/Delete: chạy request rồi map response.Data sang cả 2 kiểu key.
 * - Các method khác (Config/Header/...) trả về chính builder -> giữ Proxy trong
 *   chuỗi chaining để .Post()/.Get() phía sau vẫn được bọc.
 */
function wrapResponseBothCases(cfg) {
    const dataMethods = new Set(["Get", "Post", "Put", "Delete"]);
    const proxy = new Proxy(cfg, {
        get(target, prop) {
            const value = Reflect.get(target, prop, target);
            if (typeof value !== "function") return value;
            if (dataMethods.has(prop)) {
                return async function (...args) {
                    const result = await value.apply(target, args);
                    return wrapApiResponse(result);
                };
            }
            // Method builder (chainable): nếu trả về chính target thì trả lại
            // proxy để chuỗi chaining không "thoát" khỏi lớp bọc.
            return function (...args) {
                const ret = value.apply(target, args);
                return ret === target ? proxy : ret;
            };
        },
    });
    return proxy;
}

function configApi(keyApi, keyConfigApi) {
    Object.defineProperty($Core.Api, keyApi, {
        get() {
            var self = this,
                args = arguments;
            args;
            return function () {
                var builder = self.Make.apply(self, arguments).Config((c) => {
                    var auth = new AuthApi();
                    c.headers["Authorization"] = `Bearer ${auth.Token}`;
                    var userConfig =
                        $Core && $Core.AuthApi && $Core.AuthApi.TokenParsed
                            ? $Core.AuthApi.TokenParsed[
                                  `CauHinhRiengChoAppLaiXe_${keyConfigApi}`
                              ]
                            : null;
                    c.baseURL =
                        userConfig ||
                        window.SP[keyConfigApi] ||
                        "https://localhost:5003/";
                    // Trả về chính config để @sonphat/core gán lại vào cli.defaults.
                    return c;
                });
                // Bọc builder (sau Config) để .Get()/.Post()/... map response.Data
                // sang cả 2 kiểu key. Config() trả về builder gốc, nên phải bọc ở đây.
                return wrapResponseBothCases(builder);
            };
        },
    });
}
configApi("LenhMobile", "API_LenhDienTu");
// configApi("BenXe", "API_BenXe"); // Bỏ
configApi("CauHinhHeThong", "API_CauHinhHeThong"); // Bỏ
configApi("DiemXuongCuaKhachHang", "API_DiemXuongCuaKhachHang");
configApi("DoanhNghiepVanTai", "API_DoanhNghiepVanTai"); // Bỏ
configApi("DoiSoat", "API_DoiSoat");
configApi("DonHang", "API_DonHang");
configApi("TaiKhoan", "API_TaiKhoan");
configApi("TuyenDuong", "API_TuyenDuong"); //Bỏ
configApi("Xe", "API_Xe"); // Bỏ
configApi("ChuyenDi", "API_ChuyenDi");
configApi("Print", "API_Print");
configApi("HangHoa", "API_HangHoa");
configApi("ThongTin", "API_ThongTin");
configApi("PhienBan", "API_PhienBan");
configApi("BaoCao", "API_BaoCao");
configApi("QuanLyLenh", "API_QuanLyLenh");
configApi("QuanLyThongTinLenh", "API_QuanLyThongTinLenh");
configApi("KySoDienTu", "API_KySoDienTu");
configApi("ThongBao", "API_ThongBao");
configApi("QuanLyThongTinVe", "API_QuanLyThongTinVe"); // Thêm mới

$Core.Requests = {};

$Core.Requests.Get = async function RequestGet({ ServicesBE, url, dataGet }) {
    try {
        let result = await $Core.Api[ServicesBE || "Make"](url, dataGet).Get();
        return addBothCases(result.Data);
    } catch (ex) {
        if (ex.message == "Network Error")
            throw Error("Không kết nối được đến máy chủ!");
        throw ex;
    }
};

$Core.Requests.Post = async function RequestPost({
    ServicesBE,
    url,
    dataGet,
    dataPost,
}) {
    try {
        let resp = await $Core.Api[ServicesBE](url, dataGet || null).Post(
            dataPost
        );
        return addBothCases(resp.Data);
    } catch (ex) {}
};

export default $Core;
